module.exports = __webpack_public_path__ + "static/Srinivasa-4-a2ff5b8f2f3e246ecdd1ea082c4239aa.jpeg";